import React from 'react';

export interface ParagraphProps {
  children?: React.ReactNode | React.ReactNodeArray;
}

export function Paragraph(props: ParagraphProps) {
  let { children } = props;

  return <p className="text-gray-700 whitespace-pre-wrap break-words">{children}</p>;
}
